/* eslint-disable react/prop-types */
import { createContext, useContext } from "react";
import { useReducer } from "react";
import {
  FORM_DATA,
  NOTIFICATIONS,
  TIME_OUT,
  TRANSACTION,
  TWO_FACTOR,
} from "../../constants/constantTypes";

const initialState = {
  transaction: {
    amount: 0,
    status: "idle",
    old_balance: 0,
    new_balance: 0,
  },
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case TRANSACTION:
      return { ...state, transaction: action.payload };
    case FORM_DATA:
      return { ...state, form_data: action.payload };
    case TWO_FACTOR:
      return { ...state, two_factor_setup: action.payload };
    case TIME_OUT:
      return { ...state, time_out_status: action.payload };
    case NOTIFICATIONS:
      return { ...state, notifications: action.payload };
    default:
      return state;
  }
};
const GlobalContext = createContext();

export function GlobalContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <GlobalContext.Provider value={{ state, contextDispatch: dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
}

export default GlobalContext;
